import { IRootState } from '../../../../store'
import { IVentricularAssistDeviceState } from '../store/ventricularAssistDevice.types'

export const getVentricularAssistDeviceSelector = (state: IRootState): IVentricularAssistDeviceState =>
  state.ventricularAssistDevice
